import VanillaCalendar from "vanilla-calendar-pro";

/**
 * @param {Date} date
 * @returns {string}
 */
function formatDate(date) {
    return date.toISOString().split('T')[0];
}

class EventsFieldPeriod {
    /**
     * @param {string|HTMLElement} field
     */
    constructor(field) {
        const options = {
            input: true,
            settings: {
                lang: "it",
                selection: {
                    day: "multiple-ranged",
                },
                visibility: {
                    daysOutside: false,
                    theme: "light"
                },
            },
            actions: {
                showCalendar(self) {
                    if (self.HTMLInputElement.value) {
                        self.selectedDates = [self.HTMLInputElement.value.replace("~", ":")];
                        self.update();
                    }
                },
                clickDay(event, self) {
                    let dates = self.selectedDates;

                    /**
                     * Gestisce il range di date selezionabili nel calendario.
                     */
                    if (dates.length === 1) {
                        // È stato selezionato solo il primo giorno: imposto il range
                        let min = new Date(dates[0]);
                        let max = new Date(dates[0]);

                        min.setDate(min.getDate() - 30);
                        max.setDate(max.getDate() + 30);

                        self.settings.range.min = formatDate(min);
                        self.settings.range.max = formatDate(max);
                    } else {
                        // È stata selezionata la seconda data (dates.length uguale a 2)
                        // o la selezione è stata annullata (dates.length uguale a 0):
                        // ripristino i valori iniziali
                        self.settings.range.min = initRange.min;
                        self.settings.range.max = initRange.max;
                    }

                    self.update();
                },
                changeToInput(event, self) {
                    let dates = self.selectedDates;

                    if (dates[1]) {
                        dates.sort((a, b) => +new Date(a) - +new Date(b));
                        self.HTMLInputElement.value = `${dates[0]}~${dates[dates.length - 1]}`;
                    } else if (dates[0]) {
                        self.HTMLInputElement.value = dates[0];
                    } else {
                        self.HTMLInputElement.value = "";
                    }
                },
                initCalendar(self) {
                    self.HTMLElement.addEventListener("click", function (event) {
                        if (event.target.matches("#js-btn-close")) {
                            self.hide();
                        }
                    });
                },
            },
            DOMTemplates: {
                default: `
                    <div class="vanilla-calendar-header">
                        <#ArrowPrev />
                        <div class="vanilla-calendar-header__content">
                            <#Month />
                            <#Year />
                        </div>
                        <#ArrowNext />
                    </div>
                    <div class="vanilla-calendar-wrapper">
                        <#WeekNumbers />
                        <div class="vanilla-calendar-content">
                            <#Week />
                            <#Days />
                        </div>
                    </div>
                    <#ControlTime />
                    <button id="js-btn-close" class="c-btn -s" type="button">${i18n.calendarClose}</button>
                `,
            },
        };

        let calendar = new VanillaCalendar(field, options);
        calendar.init();

        // Salva il range iniziale delle date selezionabili, in modo da poterlo ripristinare
        let initRange = {min: calendar.settings.range.min, max: calendar.settings.range.max};
    }
}

export default EventsFieldPeriod;
